import axios, { type AxiosError } from 'axios';

import { isHmacErrorCode } from '@/constants/hmac.constant';

const getErrorPayload = (error: AxiosError): Record<string, unknown> | undefined => {
  const data = error.response?.data;
  if (!data || typeof data !== 'object') return undefined;
  return data as Record<string, unknown>;
};

export const isHmacRequestFailure = (error: unknown): boolean => {
  if (!axios.isAxiosError(error)) return false;
  const payload = getErrorPayload(error);
  if (isHmacErrorCode(payload?.code)) return true;

  const message = payload?.message;
  return typeof message === 'string' && message.toLowerCase().includes('hmac');
};
